import AxiosContent from '@/services/api/content/axios_content'

export default {
  createGDoc: (params) => {
    return AxiosContent.post(`/google/create-gdoc`, params)
  },

  editGDoc: (nodeId) => {
    return AxiosContent.put(`/google/edit-gdoc/${nodeId}`)
  },

  finishEditingGDoc: (nodeId, params) => {
    // Skip the shared response interceptor for this cleanup call. If the token
    // expired during a long editing session the finish request can return 401;
    // letting the interceptor handle it would dispatch DO_LOGOUT and clear the
    // token from localStorage, logging the user out of every open tab. A failed
    // cleanup must not tear down the whole session.
    return AxiosContent.put(`/google/finish-edit-gdoc/${nodeId}`, params, { skipInterceptor: true })
  },

  convertToGDoc: (nodeId) => {
    return AxiosContent.post(`/google/convert-to-gdoc/${nodeId}`)
  },
}
